import View from "../../../Nav/Js/views/PubliScrollToAnchorView";
import components from "./components.js";
components.define("js-PubliScrollToAnchor", View);